/**
 * 文件管理相关配置
 */

export default
{
  defXmFolders: [
    '方案',
    '现场踏勘照片',
    '调查报告',
    '实验室检测报告',
    '现场记录表格',
    '监测井照片',
    '电子照片及影像'
  ],
  uploadFile: [
    '企业图片'
  ]
}



//////////////////
// WEBPACK FOOTER
// ./static/config/fileCfg.js
// module id = null
// module chunks = 